export const DEVICES = {
  mobile: '(min-width: 0px)',
  tablet: '(min-width: 750px)',
  laptop: '(min-width: 1200px)',
  large: '(min-width: 1200px)'
}

export const COLOR_BACKGROUND_BRIGHT = '#FCF3D1';
export const COLOR_PRIMARY = '#ffc706';
export const COLOR_SECONDARY = '#1d4d9f';
export const COLOR_ACCENT = '#c86b25';
export const COLOR_ACCENT_DARK = '#5F4A32';
export const COLOR_DESCRIPTION = '#5F4A32';
